import { CREATE_LEAVE, LEAVE_APPROVE, LEAVE_APPROVE_LIST, LEAVE_APPROVE_LIST_DATEWISE, LEAVE_BALANCE, LEAVE_LIST, LEAVE_CANCEL, LEAVE_TYPE, LEAVE_BALANCE_ALL, LEAVE_BALANCE_LIST, LEAVE_APPROVED_LIST_BY_ID_YEAR, LEAVE_LIST_BY_YEAR, LEAVE_SUMMARY, CREATE_PASSOUT, PASSOUT_SUMMARY, PASSOUT_DETAILS } from "./ActionType";

const initialValue = {
    leavetypelist: [],
    leavebalancelist: [],
    leavelist: [],
    createleave: null,
    leaveapprovelist: [],
    leaveApprove: [],
    leaveapprovelistdatewise: [],
    leavecancel: [],
    allleavebalancelist: [],
    leavelistbyidandyear: [],
    leavelistbyyear: [],
    leavesummary: [],
    createpassout: [],
    passoutlist: [],
    passoutdetails: [],
}

export const leaveReducer = (store = initialValue, { type, payload }) => {

    if (type === LEAVE_TYPE) {
        return {
            ...store, leavetypelist: payload.leaveTypeList || [],
        };
    } else if (type === LEAVE_BALANCE) {
        return {
            ...store, leavebalancelist: payload.leaveBalanceList || [],
        };
    } else if (type === LEAVE_LIST) {
        return {
            ...store, leavelist: payload.leaveList || [],
        };
    } else if (type === CREATE_LEAVE) {
        return {
            ...store, createleave: payload,
        };
    } else if (type === LEAVE_APPROVE_LIST) {
        return {
            ...store, leaveapprovelist: payload.leaveList || [],
        };
    } else if (type === LEAVE_APPROVE) {
        return {
            ...store, leaveApprove: payload,
        };
    } else if (type === LEAVE_APPROVE_LIST_DATEWISE) {
        return {
            ...store, leaveapprovelistdatewise: payload,
        };
    } else if (type === LEAVE_CANCEL) {
        return {
            ...store, leavecancel: payload,
        };
    } else if (type === LEAVE_BALANCE_LIST) {
        return {
            ...store, allleavebalancelist: payload.leaveBalanceList || [],
        };
    } else if (type === LEAVE_APPROVED_LIST_BY_ID_YEAR) {
        return {
            ...store, leavelistbyidandyear: payload.leaveList || [],
        };
    } else if (type === LEAVE_LIST_BY_YEAR) {
        return {
            ...store, leavelistbyyear: payload.leaveList || [],
        };
    } else if (type === LEAVE_SUMMARY) {
        return {
            ...store, leavesummary: payload.leaveSummaryList || [],
        };
    } else if (type === CREATE_PASSOUT) {
        return {
            ...store, createpassout: payload.passoutList || [],
        };
    } else if (type === PASSOUT_SUMMARY) {
        return {
            ...store, passoutlist: payload.passoutList || [],
        };
    } else if (type === PASSOUT_DETAILS) {
        return {
            ...store, passoutdetails: payload.passout || [],
        };
    }

    return store
}